<template>
  <BlueprintHeader ref="header" :show-title="showTitle" :pages="pages" :page-sizes="pageSizes" :num-items="count"
    :loading="isLoading" @search="search" @add="actionAdd = {}" @upload="goToUpload" />
  <!-- Issue 622: a failed PDF download used to go only to the console, so the link looked like it did
       nothing at all. Say so on screen. -->
  <div v-if="pdfError" class="alert alert-danger alert-dismissible py-2 mb-2">
    {{ pdfError }}
    <button type="button" class="btn-close" @click="pdfError = null"></button>
  </div>
  <div class="table-responsive">
    <Overlay v-if="isLoadingInspection" />
    <div class="custom-listing-inspections" :style="listingHeight">
      <z-table v-model="records" class="table table-bordered table-striped" :is-single-row-detail="false"
        :is-header-fixed="isHeaderFixed" :sort-by="sortBy" :order-by="orderBy" :columns="tableColumnsName"
        :detail-column-class="detailColumnClass" :isRowClickable="true" :loading="isLoading" @sort="setOrder"
        @click="viewDetails" @mousedown="showingDetails = true">
        <template #tbody="props">
          <td>
            {{ formatDate(props.row.createdOn) }}
          </td>
          <td style="position: relative">
            <a v-if="props.row.isViewable" href="#" @click="viewInspection(props.row)">{{ props.row.adasInspection
            }}</a>
            <span v-else>{{ props.row.adasInspection }}</span>
            <div v-if="props.row.numNotes > 0" class="custom-notes-icon">
              <span>{{ props.row.numNotes }}</span>
              <i class="fas fa-sticky-note"></i>
            </div>
          </td>
          <td>{{ props.row.ronumber }}</td>
          <td>
            <a v-if="props.row.isPdf && props.row.repairDocument" href="#" @click.prevent="downloadPdf(props.row)"
              title="Download the uploaded PDF estimate">{{ props.row.estimateSource }} (PDF)</a>
            <span v-else>{{ props.row.estimateSource || 'VIN' }}</span><!-- Issue 663: no source = VIN-only scrub -->
          </td>
          <td :class="setStatusClass(props.row.status)">{{ props.row.status }}</td>
          <td>{{ props.row.year }}</td>
          <td>{{ props.row.make }}</td>
          <td>{{ props.row.model }}</td>
          <td>{{ props.row.vin }}</td>
          <!-- <td class="custom-column-100 text-center">{{ getCounts(props.row) }}</td> -->
          <td v-if="props.row.services" class="custom-column-100 text-center custom-status">
            <div class="custom-status-box" :class="setWorkStatusClass(props.row)">
              <span>{{ props.row.itemsComplete }}</span>
              <span class="ms-1 me-1">/</span>
              <span>{{ getCounts(props.row)
              }}</span><!-- Don't use itemsSent here because we may actually still need to send them!-->
            </div>
          </td>
          <td v-else></td>
          <td>
            <a href="#" @click="viewBuild(props.row)">
              Build Data
            </a>
          </td>
        </template>
        <!-- <template #detail="props">
          <BlueprintDetail :inspection="props.row" />
        </template> -->
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
  <DialogAddInspection v-model="actionAdd" @closing="closeAdd" @open="openAdded" />
  <DialogBuild v-model="actionBuild" @closing="closeModal" />
  <DialogBlueprint v-model="actionBlueprint" @report="openReport" @closing="closeModal" @saved="savedInspection"
    @refresh="savedInspection" />
  <DialogInspectionReport v-model="actionReport" @closing="closeReportModal" :title="reportTitle" />
  <BlueprintRecord v-show="showDetails" ref="detailsPopup" name="detailsPopup" :inspection="details"
    @close="showDetails = false" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { inspectionStore } from '@/stores/inspection'
import { lookupStore } from '@/stores/lookup'
import { buildStore } from '@/stores/build'
import globals from '@/plugins/globals'
import axios from 'axios'
import ZTable from '@/components/utilities/elements/Table.vue'
import BlueprintHeader from './BlueprintHeader.vue'
import DialogBlueprint from './forms/DialogBlueprint.vue'
import DialogInspectionReport from './report/InspectionReport.vue'
import DialogBuild from './forms/DialogBuild.vue'
import DialogAddInspection from './forms/DialogAddInspection.vue'
import BlueprintRecord from './BlueprintRecord.vue'
import Overlay from '@/components/utilities/elements/Overlay.vue'
export default {
  name: 'BlueprintListing',
  components: {
    ZTable,
    BlueprintHeader,
    DialogBlueprint,
    DialogInspectionReport,
    DialogBuild,
    DialogAddInspection,
    BlueprintRecord,
    Overlay
  },
  props: {
    isHeaderFixed: {
      type: Boolean,
      default: false
    },
    listingHeight: String
  },
  data() {
    return {
      actionBlueprint: null,
      actionBuild: null,
      actionAdd: null,
      // Shown when a source-PDF download fails, so the link never fails silently.
      pdfError: null,
      page: 1,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      detailColumnClass: 'custom-column-60',
      reportTitle: null,
      actionReport: null,
      showDetails: false,
      showingDetails: false,
      details: null
    }
  },
  async mounted() {
    this.page = 1
    this.isAdd = false
    this.showingDetails = false
    this.showDetails = false
    document.addEventListener('click', this.handleClickOutside);
    this.setListParam({
      name: 'filter',
      value: null
    })
    this.setListParam({
      name: 'firm',
      value: this.profile.firm
    })
    await this.getLookups({
      keys: ['Status', 'Reason', 'SystemType', 'CCCItemType', 'Insurance'],
      firm: 1,
      refresh: false
    })
    await this.search()
  },
  emits: ['loading'],
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, { lookupLoading: 'loading' }),
    ...mapState(inspectionStore, ['loading', 'listParams', 'inspections', 'inspection']),
    count() {
      return this.inspections.count
    },
    records() {
      let _items = []
      if (this.inspections && this.inspections.items) {
        _items = this.inspections.items.map((item) => ({
          ...item,
          isViewable: true // item.statusName !== 'Pending' // isViewable is false if status is "Pending", true otherwise
        }))
      }
      return _items
    },
    tableColumnsName() {
      let columns = [
        { field: 'createdOn', label: 'Created', sortable: true },
        { field: 'adasInspection', label: 'Inspection #', sortable: true, },
        { field: 'ronumber', label: 'RO #', sortable: true },
        { field: 'estimateSource', label: 'Source', sortable: true },
        { field: 'statusName', label: 'Status', sortable: true },
        { field: 'year', label: 'Year', sortable: false },
        { field: 'make', label: 'Make', sortable: true },
        { field: 'model', label: 'Model', sortable: false },
        { field: 'vin', label: 'VIN', sortable: true },
        { field: 'numberSystems', label: 'Sync', sortable: false, class: 'custom-column-100  text-center' }
      ]
      return columns
    },
    pages() {
      return Math.ceil(this.inspections.count / this.listParams.pageSize)
    },
    sortBy() {
      return this.listParams.sortBy
    },
    orderBy() {
      return this.listParams.orderBy
    },
    isLoading() {
      let _is = false
      if (this.loading.inspections) {
        _is = true
      }
      return _is
    },
    isLoadingInspection() {
      let _is = false
      if (this.loading.inspection) {
        _is = true
      }
      return _is
    },
    isViewingCompleted() {
      return this.listParams.status === '4'
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups']),
    ...mapActions(inspectionStore, ['setListParam', 'getInspection', 'getInspections']),
    ...mapActions(buildStore, ['getBuild']),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    // #668: refresh the grid if the Add dialog created an inspection the user didn't open
    closeAdd(isCreated) {
      this.actionAdd = null
      if (isCreated) this.search(this.page)
    },
    openAdded(data) {
      this.actionAdd = null
      this.actionBlueprint = data
      this.search(this.page)
    },
    // Issue 622: open the PDF upload/review page (from the header "Upload PDF" button).
    goToUpload() {
      this.$router.push('/upload-estimate')
    },
    // Issue 622: download the retained source PDF behind a "PDF(C)/PDF(M)" cell. The ADAS Map endpoint
    // is firm-scoped, so it only returns the file when the caller's firm owns the inspection.
    async downloadPdf(row) {
      if (!row || !row.repairDocument) return
      this.pdfError = null
      try {
        const apiUrl = window.config ? window.config.apiUrl : ''
        const resp = await axios.get(`${apiUrl}/bms/pdf/document/${row.repairDocument}/download`, {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${authStore().token}` }
        })
        const url = URL.createObjectURL(resp.data)
        const a = document.createElement('a')
        a.href = url
        a.download = `estimate-${row.repairDocument}.pdf`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        const status = e && e.response && e.response.status
        this.pdfError = status === 404
          ? 'That estimate PDF is no longer available for this inspection.'
          : 'The estimate PDF could not be downloaded. Try again, or open the inspection in a different browser.'
        // eslint-disable-next-line no-console
        console.error('downloadPdf failed', e)
      }
    },
    formatNumber(value) {
      return globals.formatNumber(value)
    },
    handleClickOutside(event) {
      const popup = this.$refs.detailsPopup;
      if (popup && !this.showingDetails) {
        this.showDetails = false;
        this.showingDetails = false;
      }
    },
    closeModal() {
      this.actionBlueprint = null
      this.actionReport = null
      this.actionBuild = null
      this.reportTitle = null
    },
    closeReportModal() {
      this.actionReport = null
      this.reportTitle = null
    },
    openReport(data) {
      this.reportTitle = `# ${data.adasInspection}`
      this.actionReport = data
    },
    async viewBuild(data) {
      this.showDetails = false
      this.showingDetails = false
      this.$emit('loading', true)
      await this.getBuild(data.adas)
      this.showDetails = false
      this.showingDetails = false
      this.$emit('loading', false)
      this.actionBuild = true
    },
    async setOrder(column, sortBy) {
      this.page = 1
      this.setListParam({
        name: 'sortBy',
        value: sortBy
      })
      this.setListParam({
        name: 'orderBy',
        value: column.field
      })
      await this.search(this.page)
    },
    setStatusClass(status) {
      let _class = ''
      if (status === 'Active') {
        _class = 'statusSubmitted'
      } else if (status === 'InProcess') {
        _class = 'statusWorking'
      } else if (status === 'NoAction') {
        _class = 'statusCancelled'
      } else {
        _class = 'statusCompleted'
      }
      return _class
    },
    setWorkStatusClass(row) {
      let _class = ''
      if (row.services) {
        let total = this.getCounts(row)
        if (total === row.itemsComplete) {
          _class = 'workStatusSuccess'
        } else if (row.itemsComplete > 0 && row.itemsSent < total) {
          _class = 'workStatusWarning'
        } else {
          _class = 'workStatusDanger'
        }
      }
      return _class
    },
    async search(page = 1) {
      // Load up the Inspections
      try {
        this.page = page
        await this.getInspections({
          page: this.page,
          offset: (this.page - 1) * this.listParams.pageSize,
          sortBy: this.listParams.sortBy,
          orderBy: this.listParams.orderBy,
          pageSize: this.listParams.pageSize,
          searchTerm: this.listParams.searchTerm,
          filter: this.listParams.filter,
          status: this.listParams.status,
          firm: this.listParams.firm !== undefined && this.listParams.firm !== null ? this.listParams.firm : this.profile.firm,
          userId: this.profile.user
        })
      } catch (e) {
        console.log('Error', e)
      }
    },
    getCounts(data) {
      let count = null
      if (data) {
        if (data.services) {
          count = data.services.length
          count += data.itemsFIT ? parseInt(data.itemsFIT) : 0 //Leaving this in place because if it exists already then the counts will be off otherwise
          count += data.itemsIVS ? parseInt(data.itemsIVS) : 0
        }
      }
      return count
    },
    viewDetails(row) {
      this.details = row
      this.showDetails = true
      setTimeout(() => {
        this.showingDetails = false
      }, 100);
    },
    async viewInspection(data) {
      this.showDetails = false
      this.showingDetails = false
      await this.getInspection(data.adasInspection)
      this.showDetails = false
      this.showingDetails = false
      this.actionBlueprint = data
    },
    savedInspection() {
      this.search(this.page)
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
}
</script>
<style lang="scss" scoped>
.loadingWrapper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 10;
}

.custom-listing-inspections {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 650px;
  height: 100%;
}

.custom-header {
  position: sticky;
  top: 0;
}

.custom-loading-inspection {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.3);

  .loading-spinner {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    font-weight: 700;
    padding: 10px;
    z-index: 12;
    background-color: white;
    height: 45px;
    width: 150px;
    border-radius: 5px;

    span {
      margin-left: 5px;
      background-color: #fff;
    }
  }
}

.custom-notes-icon {
  position: absolute;
  top: 0;
  right: 5px;
  color: #0d6efd;
  font-size: 0.8em;

  span {
    font-size: 11px;
    color: rgb(0, 0, 0);
    margin-right: 2px;
  }
}

.custom-circle {
  display: inline-flex;
  /* Aligns text inside the circle */
  justify-content: center;
  /* Centers text horizontally */
  align-items: center;
  /* Centers text vertically */
  background-color: red;
  /* Circle background color */
  color: white;
  /* Text color */
  width: 20px;
  /* Fixed width for the circle */
  height: 20px;
  /* Fixed height for the circle */
  border-radius: 50%;
  /* Makes it a circle */
  font-weight: bold;
  /* Makes the number bold */
}

.statusPending {
  font-weight: 500;
  color: red;
}

.statusSubmitted {
  font-weight: 500;
  color: blue;
}

.statusWorking {
  font-weight: 500;
  color: green;
}

.statusCompleted {
  font-weight: 500;
  color: black;
}

.statusCancelled {
  font-weight: 500;
  color: rgb(116, 0, 0);
}

.statusAssigned {
  font-weight: 500;
  color: rgb(0, 121, 190);
}

.statusPaid {
  font-weight: 600;
  color: green;
}

.custom-status {
  font-size: 1em;
  font-weight: 600;
  position: relative;
  text-align: center;
  vertical-align: middle;
  height: 100%;
}

.custom-status-box {
  display: inline-block;
  border-radius: 5px;
  padding: 10px;
}

.workStatusDanger {
  background-color: red;
  color: #ffffff;
}

.workStatusWarning {
  background-color: yellow;
  color: #000;
}

.workStatusSuccess {
  background-color: green;
  color: #ffffff;
}

.cursor-background:hover {
  background-color: #f0f0f0;
}
</style>
